import { useTenantConfig } from 'contexts';
import * as React from 'react';
import { CommonRegionPickerProps } from 'types';
import { PopupTerminalPickerMobile } from './mobile/PopupTerminalPickerMobile';
import { PopupTerminalPickerDesktop } from './desktop/PopupTerminalPickerDesktop';

export type PopupTerminalPickerProps = Pick<
  CommonRegionPickerProps,
  'showPopup' | 'onClosePopup'
> & {};
export const PopupTerminalPicker = ({ ...props }: PopupTerminalPickerProps) => {
  const { isMobile } = useTenantConfig();
  if (isMobile) {
    return <PopupTerminalPickerMobile {...props} />;
  }

  return <PopupTerminalPickerDesktop {...props} />;
};
